import { render, staticRenderFns } from "./CBSR.vue?vue&type=template&id=7d73f2f4&scoped=true&"
import script from "./CBSR.vue?vue&type=script&lang=ts&"
export * from "./CBSR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d73f2f4",
  null
  
)

export default component.exports